import { createFileRoute, redirect } from '@tanstack/react-router';
import { Pane } from '@sheridan-prize/ui';
import { SpSidebar } from '../components/Sidebar';
import { ProfileJuror } from '../components/EnhancedProfileJuror';
import { getAuthStore } from '../main';
import { ProfileArtist } from '../components/EnhancedProfileArtist';
import { AccountHeader } from '../components/AccountHeader';

export const Route = createFileRoute('/profile')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    await getAuthStore().fetchUserDoc();

    const isAuthenticated = getAuthStore().getIsAuthenticated();
    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    const userRole = getAuthStore().getUser()?.role;
    if (userRole !== 'juror' && userRole !== 'artist') {
      throw redirect({ to: '/' });
    }
  },
  component: Profile,
});

function Profile() {
  const useAuthStore = getAuthStore();
  const userRole = useAuthStore.getUser()?.role;

  return (
    <>
      <AccountHeader />
      <div className="app">
        <SpSidebar />
        <Pane classes={'sp-main'} tag="main">
          <h1>Your Profile</h1>
          {userRole === 'juror' ?
            <ProfileJuror />
          : <ProfileArtist />}
        </Pane>
      </div>
    </>
  );
}
